var l = Object.defineProperty, p = (s, t, e) => t in s ? l(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e, n = (s, t, e) => (p(s, typeof t != "symbol" ? t + "" : t, e), e);
const m = (s) => s.error !== void 0 && s.error_code !== void 0 && s.result !== void 0 && s.request_id !== void 0, d = class extends Error {
  constructor(t) {
    super(t.message, { cause: t.cause }), n(this, "method"), n(this, "url"), n(this, "data"), n(this, "statusCode"), n(this, "backendError"), this.name = "HttpClientError", this.method = t.method, this.url = t.url, this.data = t.data ? JSON.stringify(t.data) : void 0, this.statusCode = t.status, this.backendError = t.backendError;
  }
};
n(d, "fromResponse", ({
  method: s,
  url: t,
  data: e,
  status: r,
  responseData: a
}) => {
  if (m(a))
    return new d({
      message: a.error,
      method: s,
      url: t,
      data: e,
      status: r,
      backendError: a
    });
}), n(d, "fromError", ({
  method: s,
  url: t,
  data: e,
  error: r
}) => {
  const a = r instanceof Error ? r.message : "UNKNOWN_ERROR";
  return new d({
    message: a,
    method: s,
    url: t,
    data: e,
    cause: r
  });
});
let c = d;
class E {
  constructor(t) {
    n(this, "token"), this.config = t, t.token && this.setToken(t.token);
  }
  setToken(t) {
    this.token = t;
  }
  async get(t, e) {
    return this.request("GET", t, e);
  }
  async post(t, e, r) {
    return this.request("POST", t, { data: e, ...r });
  }
  async put(t, e, r) {
    return this.request("PUT", t, { data: e, ...r });
  }
  async patch(t, e, r) {
    return this.request("PATCH", t, { data: e, ...r });
  }
  async delete(t, e) {
    return this.request("DELETE", t, e);
  }
  async request(t, e, r) {
    const { data: a, ...i } = r || {}, u = this.getRequestUrl(t, e, i);
    try {
      const o = await fetch(u, this.getRequestOptions(t, a, i)), h = await o.json();
      if (!o.ok)
        throw c.fromResponse({
          method: t,
          url: u.href,
          data: a,
          status: o.status,
          responseData: h
        });
      return h;
    } catch (o) {
      throw o instanceof c ? o : c.fromError({
        method: t,
        url: u.href,
        data: a,
        error: o
      });
    }
  }
  getRequestUrl(t, e, r) {
    const a = this.config.baseUrl + e, i = new URL(a);
    if (t === "GET") {
      const u = (r == null ? void 0 : r.params) ?? {};
      Object.entries(u).forEach(([o, h]) => {
        i.searchParams.append(o, h.toString());
      });
    }
    return i;
  }
  getRequestOptions(t, e, r) {
    return {
      ...r,
      method: t,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...this.token ? { Authorization: `Token ${this.token}` } : {},
        ...r == null ? void 0 : r.headers
      },
      body: t !== "GET" && e !== void 0 ? JSON.stringify(e) : void 0
    };
  }
}
export {
  E as HttpClient,
  c as HttpClientError,
  m as isBackendHttpErrorResponse
};
//# sourceMappingURL=index.es488.js.map
